<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    progress: {
        required: true,
        type: Object,
    },
});

const percent = computed(() => {
    return Math.round((props.progress.current / props.progress.total) * 100);
});

const isCompleted = computed(() => {
    return percent.value === 100;
});

const circumference = ref(30 * 2 * Math.PI);
</script>

<template>
    <div class="inline-flex items-center justify-center overflow-hidden rounded-full">
        <!-- Building a Progress Ring: https://css-tricks.com/building-progress-ring-quickly/ -->
        <svg class="w-20 h-20">
            <circle
                class="text-gray-300"
                stroke-width="5"
                stroke="currentColor"
                fill="transparent"
                r="30"
                cx="40"
                cy="40"
            />
            <circle
                :class="isCompleted ? 'text-green-600' : 'text-blue-600'"
                stroke-width="5"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="circumference - (percent / 100) * circumference"
                stroke-linecap="round"
                stroke="currentColor"
                fill="transparent"
                r="30"
                cx="40"
                cy="40"
            />
        </svg>
        <span class="absolute">
            <slot></slot>
        </span>
    </div>
</template>
